import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpContext } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/services/base.service';
import { NOTIFICATION } from '../constans/endpoint.const';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
    private allNotifications$?: Observable<any[]>;
  
    constructor(private baseService: BaseService) {}
  
    private fetchNotifications(): Observable<any[]> {
        const params = {
            product: 'affiliate'
        }
        if (!this.allNotifications$) {
          const dismissedRaw = localStorage.getItem('dismissedBanners') || '[]';
          let dismissed: number[] = [];
          try {
            const parsed = JSON.parse(dismissedRaw);
            dismissed = Array.isArray(parsed) ? parsed.map(Number) : [];
          } catch {
            dismissed = [];
          }
          
        this.allNotifications$ = this.baseService
        .getDataWithToken(NOTIFICATION, params).pipe(
          map((res: any) =>
            res.data.map((item: any) => {
              let isVisible = true;
              if (item.type === 'banner') {
                if (!item.is_reccurring && dismissed.includes(item.id)) {
                  isVisible = false;
                }
              }
  
              return {
                ...item,
                isVisible,
              };
            })
          ),
          shareReplay(1)
        );
      }
  
      return this.allNotifications$;
    }
  
    getBanners(): Observable<any[]> {
      return this.fetchNotifications().pipe(
        map((items) => items.filter((item) => item.type === 'banner' && item.isVisible))
      );
    }
  
    getMessages(): Observable<any[]> {
      return this.fetchNotifications().pipe(
        map((items) => items.filter((item) => item.type === 'message' && item.isVisible))
      );
    }
  
    resetNotificationCache() {
      this.allNotifications$ = undefined;
    }
  }
